const regex = /{(.*?)}/g;

export const getBadgesFromPlainText = (text: string) => {
  const matches = text.match(regex);
  return matches?.map((match: string) => match.slice(1, -1)) ?? [];
};

/**
 * Resolves the effective icon_category_id after a category list change.
 *
 * - If the current id is still in the new list, keep it.
 * - If null and the tool previously had categories, the admin explicitly chose "Default" — keep null.
 * - If null and there were no prior categories, null is uninitialized — auto-select the first new category.
 * - If the current id is no longer in the new list (stale), fall back to the first category.
 */
export function resolveIconCategoryId(
  toolDetails: { tool: { icon_category_id: string | null }; categories: { id: string }[] },
  nextCategories: { id: string }[],
): string | null {
  const currentIconId = toolDetails.tool.icon_category_id;
  const hadCategories = toolDetails.categories.length > 0;
  const firstCategoryId = nextCategories[0]?.id ?? null;
  const currentIsStillValid = nextCategories.some((c) => c.id === currentIconId);

  if (currentIconId === null) {
    // null is ambiguous: either the admin explicitly chose "Default", or the tool has never had a category.
    // Only treat it as a sticky explicit choice if categories existed before — otherwise auto-select the first.
    if (hadCategories) return null;
    return firstCategoryId;
  }

  if (currentIsStillValid) return currentIconId;

  // Current selection was removed — fall back to the first remaining category.
  return firstCategoryId;
}
